export enum TapTypeEnum {
  TAP = 'TAP', // validation
  TAP_CONTROL = 'TAP_CONTROL',
  TAP_IN = 'TAP_IN',
  TAP_INITIATED = 'TAP_INITIATED',
  TAP_OUT = 'TAP_OUT',
  TAP_PR = 'TAP_PR'
}
